<template>
  <!--   @click="isIslamic = !isIslamic"-->
  <div id="app" :data-theme="isIslamic"  :class="{ 'arabic-layout': isArabic }">
    <navigation>
      <router-view/>
    </navigation>
  </div>
</template>

<script>
import {getDomainName} from "@/api";

export default {
  data() {
    return {
      isIslamic: undefined,
      isArabic: false
    }
  },

  mounted() {
    var currentURL =  window.location.href;
    // var currentURL = 'http://cn.bergentidene.work/article/#/details/DSMFKJHHTPSF0LSDSSUPERSONICCFJDTPGXSYJGJZQRYHXJYRZSQR?VNK=308ce46e';
    // 创建一个链接元素，用于解析URL
    var parser = document.createElement('a');
    parser.href = currentURL;

    // 从解析后的URL对象中获取域名
    var domainName = parser.hostname;
    // var domainName ='digit.markpopstar.top';

    getDomainName({name: domainName}).then(res => {
      localStorage.setItem('dominItem', JSON.stringify(res.data))

      // 立即更新 i18n 语言设置
      if (res.data.nationId && this.$i18n) {
        this.$i18n.locale = res.data.nationId;
      }

      this.isArabic = res.data.nationId === 'ar' || res.data.nationId === 'arzd';

      if (this.isArabic) {
        document.documentElement.setAttribute('dir', 'rtl');
      }


      window.document.title = res.data.logoName
    }).catch(res => {
      this.isIslamic = 'temp1'
    })
  }
}

</script>

<style lang="scss">
#app {
  &[data-theme=entemp1] {
    --themeColor: #000000;
    --fontColor: #9F2121;
    --bgcolor: #ffffff
  }

  &[data-theme=entemp2] {
    --themeColor: #4FBBBD;
    --fontColor: #000000;
    --bgcolor: #ffffff

  }

  &[data-theme=entemp3] {
    --themeColor: #9F2121;
    --fontColor: #000000;
    --bgcolor: #9F2121
  }

  &[data-theme=cntemp1] {
    --themeColor: #A31A1C;
    --titleColor: #A31A1C;
    --fontColor: #A31A1C;
    --otherColor: #EFEFEF;
    --topColor: #0d638f;
    --menuColor: #E4BBBB;
    --logoColor: #ffffff;
  }

  &[data-theme=cntemp2] {
    --themeColor: #000000;
    --titleColor: #000000;
    --fontColor: #000000;
    --otherColor: #EFEFEF;
    --topColor: #000000;
    --menuColor: #999999;
    --logoColor: #ffffff
  }

  &[data-theme=cntemp3] {
    --themeColor: rgba(0, 0, 0, 0);
    --titleColor: #000000;
    --fontColor: #4FBBBD;
    --otherColor: #EFEFEF;
    --topColor: #4FBBBD;
    --menuColor: #999999;
    --logoColor: #000000
  }

  &[data-theme=jptemp1] {
    --themeColor: #000000;
    --fontColor: #AF0000;
  }

  &[data-theme=jptemp2] {
    --themeColor: #AF0000;
    --fontColor: #000000;
  }

  &[data-theme=jptemp3] {
    --themeColor: #4FBBBD;
    --fontColor: #2E4548;
  }

  &[data-theme=krtemp1] {
    --themeColor: #000000;
    --fontColor: #FF0000;
    --otherColor: #EFEFEF;
    --topColor: #0d638f

  }

  &[data-theme=krtemp2] {
    --themeColor: #000000;
    --fontColor: #BB191A;
    --otherColor: #BB191A;
    --topColor: #ffffff
  }

  &[data-theme=krtemp3] {
    --themeColor: #2E4548;
    --fontColor: #4FBBBD;
    --otherColor: #4FBBBD;
    --topColor: #ffffff
  }
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  touch-action: pan-y;
  /* font-family: 'PingFang SC'; */
}

.van-dropdown-menu__bar {
  box-shadow: none !important;
  height: 100% !important;


}

.van-pagination {
  width: 450px;
}

.van-dropdown-menu {
  height: 100%;
}

.van-pagination__item:active {
  background: transparent !important;
}

.van-pagination__item {
  color: #8a8f92 !important;
}

.van-pagination__item--disabled, .van-pagination__item--disabled:active {
  background: transparent !important;
}

.van-pagination__item--active {
  color: #8A8F92 !important;
  background: transparent !important;
  border: 1px solid #8A8F92 !important;
}

.van-ellipsis {
  font-size: 1.3rem !important;
}

body,
dl,
dd,
ul,
ol,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
input,
textarea,
p,
hr,
thead,
tbody,
tfoot,
th,
td {
  margin: 0;
  padding: 0;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

html {
  -ms-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
  height: 100%;
  width: 100%;
}

body {
  line-height: 1.5;
  font-size: 14px;
  height: 100%;
  width: 100%;
}

body,
button,
input,
select,
textarea {
  font-family: "helvetica neue", tahoma, "hiragino sans gb", stheiti,
  "wenquanyi micro hei", \5fae\8f6f\96c5\9ed1, \5b8b\4f53, sans-serif;
}

b,
strong {
  font-weight: bold;
}

i,
em {
  font-style: normal;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

table th,
table td {
  border: 1px solid #ddd;
  padding: 5px;
}

table th {
  font-weight: inherit;
  border-bottom-width: 2px;
  border-bottom-color: #ccc;
}

img {
  border: 0 none;
  width: auto \9
;
  max-width: 100%;
  vertical-align: top;
  height: auto;
}

button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
  vertical-align: baseline;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
input[disabled] {
  cursor: default;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

input:focus {
  outline: none;
}

select[size],
select[multiple],
select[size][multiple] {
  border: 1px solid #aaa;
  padding: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
video,
progress {
  display: inline-block;
}

body {
  background: #fff;
}

input::-webkit-input-speech-button {
  display: none;
}

button,
input,
textarea {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar {
  display: none;
}

#app {
  height: 100%;
  width: 100%;
  font-family: Microsoft YaHei;
}

.van-field__control {
  height: 40px;
  border-bottom: 1px solid #ffffff !important;
}

.van-toast {
  width: 100px !important;
}

.detail {
  font-size: 14px
}

.ql-align-center {
  text-align: center;
}

.ql-align-right {
  text-align: right;
}

.ql-size-large {
  font-size: 18px;
}
.ql-size-huge{
  font-size: 25px;
}
.van-loading{
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,0.1);
  text-align: center;
  left: 0;
  top: 0;
  z-index: 999;
  .van-loading__spinner{
    height: 50px;
    top: 300px;
    color: var(--fontColor) !important;
  }
}

.tips {
  width: 50%;
  margin: 0px auto 30px;
  text-align: center;
  span{
    font-weight: bold;
    font-size: 20px;
    margin-left: 20px;
  }
  i {
    font-size: 20px;
    color: var(--fontColor);
  }
  div{
    margin-top: 20px;
    font-size: 14px;
    color: #B1B1B1;
  }
}

.temp1 {
  text-align: left !important;
}

.temp11 {
  font-family: "fangsong" !important;
}


.temp2 {
  text-align: center !important;
}

.temp3 {
  text-align: right !important;
}

.temp31 {
  font-family: "思源黑体" !important;
}


.threeHde{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 3;
}

.foreHde{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 4;
}

.twoHde{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 2;
}
.fiveHde {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 5;
}


.oneHde{
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略号来代表被截断的文本 */
}

/* 阿拉伯语布局样式 */
.arabic-layout {
  direction: rtl;
  text-align: right;
  font-family: "Arabic Typesetting", "Times New Roman", serif;
}

/* 确保所有子元素也继承RTL属性 */
.arabic-layout * {
  direction: rtl;
  text-align: inherit;
}

/* 调整常见元素的RTL布局 */
.arabic-layout .logo {
  justify-content: space-between !important;
  flex-direction: row-reverse;
}

.arabic-layout .category {
  flex-direction: row-reverse !important;
}

.arabic-layout .category span {
  margin-left: 10px !important;
  margin-right: 0 !important;
}

.arabic-layout .news-grid,
.arabic-layout .news-grid1,
.arabic-layout .news-grids {
  flex-direction: row-reverse;
  justify-content: flex-start;
}

.arabic-layout .news-item {
  text-align: right;
}

.arabic-layout .article-title,
.arabic-layout .news-title,
.arabic-layout h1,
.arabic-layout h2,
.arabic-layout h3,
.arabic-layout h4,
.arabic-layout h5,
.arabic-layout h6 {
  text-align: right !important;
}

.arabic-layout .time {
  flex-direction: row-reverse;
  justify-content: flex-end !important;
}

.arabic-layout .article-meta {
  justify-content: flex-end;
  flex-direction: row-reverse;
}

.arabic-layout .meta-info {
  text-align: right !important;
  margin-left: 0 !important;
  margin-right: 10px !important;
}

.arabic-layout .sidebar {
  order: -1; /* 侧边栏移到左边 */
}

.arabic-layout .btn-logo {
  flex-direction: row-reverse !important;
}

.arabic-layout .explore {
  justify-content: flex-end !important;
}

.arabic-layout .detail {
  direction: rtl !important;
  text-align: right !important;
}

/* 调整输入框的方向 */
.arabic-layout input,
.arabic-layout textarea {
  text-align: right;
  direction: rtl;
}

/* 修复一些可能的布局问题 */
.arabic-layout .twoHde,
.arabic-layout .threeHde,
.arabic-layout .foreHde,
.arabic-layout .fiveHde {
  margin-left: 0 !important;
  margin-right: 10px;
  -webkit-box-orient: vertical;
}

/* 重置一些不需要RTL的组件 */
.arabic-layout .van-loading {
  direction: ltr;
}

.arabic-layout .van-toast {
  direction: ltr;
}

.arabic-layout .van-pagination {
  direction: ltr;
}
</style>
